import { orderDraftRepository } from '@webapp/modules/purchasing/data-access/repositories/OrderDraftRepository'
import { GetAutomationOrderDraftUseCase } from './GetAutomationOrderDraftUseCase'

export const getAutomationOrderDraftUseCase =
  new GetAutomationOrderDraftUseCase({
    orderDraftRepository,
  }).execute
